import { render, staticRenderFns } from "./mega-radio.vue?vue&type=template&id=9738863a"
import script from "./mega-radio.vue?vue&type=script&lang=js"
export * from "./mega-radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports